import { useEffect, useRef, useState } from 'react'
import { updateCrmContact } from '../../db/api.js'

const demo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
// Mesma lista fixa usada em ClienteFormPanel.jsx — origem é texto livre no
// banco (contacts_unified.origem / user_data.source), isto é só sugestão.
const ORIGEM_OPTS = ['Indicação', 'Site', 'Redes sociais', 'Evento', 'Cold outreach', 'Anúncio', 'Parceria', 'Outro']

export default function DealOrigin({ dealId, lead, onSaved }) {
  const current = lead?.origem || ''
  const [options, setOptions] = useState(ORIGEM_OPTS)
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const [open, setOpen] = useState(false)
  const [detailsOpen, setDetailsOpen] = useState(false)
  const root = useRef(null)
  const trigger = useRef(null)
  useEffect(() => {
    if (!open) return
    const outside = (event) => { if (!root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open])
  useEffect(() => {
    let alive = true
    if (demo) import('../../demo/data.js').then((m) => { if (alive) setOptions(m.getDemoOrigins()) }).catch(() => { if (alive) setError('Não foi possível carregar as origens.') })
    return () => { alive = false }
  }, [])
  const change = async (value) => {
    if (!demo && !lead?.contact_id) { setError('Selecione um lead principal para o negócio primeiro.'); return }
    setError(''); setSaving(true)
    try {
      if (demo) {
        const { saveDemoOrigin } = await import('../../demo/data.js')
        onSaved(saveDemoOrigin(dealId, value))
      } else {
        await updateCrmContact(lead.contact_id, { origem: value || null })
        onSaved({ origem: value })
      }
      setOpen(false); trigger.current?.focus()
    } catch (err) { setError(err.message) }
    finally { setSaving(false) }
  }
  return <div className="dp-company-cnpj dp-origin" ref={root} onKeyDown={(event) => { if (open && event.key === 'Escape') { event.stopPropagation(); setOpen(false); trigger.current?.focus() } }}>
    <span className="cv-row-label">Origem</span>
    <button type="button" ref={trigger} className="dp-origin-trigger" aria-label={`Alterar origem: ${current || 'Não informada'}`} aria-expanded={open} onClick={() => setOpen(!open)}>{current || 'Não informada'}</button>
    <button type="button" className="dp-origin-details-toggle" aria-expanded={detailsOpen} aria-controls={`origin-details-${dealId}`} onClick={() => { setOpen(false); setDetailsOpen(!detailsOpen) }}>{detailsOpen ? 'Ocultar detalhes' : 'Ver detalhes'}</button>
    {detailsOpen && <div id={`origin-details-${dealId}`} className="dp-origin-details">
      <span>Origem: {current || 'Não informada'}</span>
      <p>Nenhuma informação adicional cadastrada sobre esta origem.</p>
    </div>}
    {open && <div className="dp-origin-options" role="group" aria-label="Escolher origem">
      {['', ...new Set([current, ...options].filter(Boolean))].map((value) => <button type="button" key={value} disabled={saving} aria-pressed={current === value} onClick={() => change(value)}>{value || 'Não informada'}</button>)}
    </div>}
    {error && <small role="alert">{error}</small>}
  </div>
}
